import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import '@/assets/stylus/main.styl'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
    options: {
      customProperties: true
    }
  }
})
